import { createContext as x, useContext as T } from "react";
import { a as i } from "../../../vanilla-CSAfDK5R.js";
const f = () => {
  const o = i([]), d = i(
    null,
    (c, n, a, s) => {
      const t = c(o), e = t.findIndex((m) => m.toastId === a), r = {
        ...s,
        toastId: a
      };
      e > -1 ? n(o, [
        ...t.slice(0, e),
        r,
        ...t.slice(e + 1)
      ]) : n(o, [...t, r]);
    }
  ), l = i(null, (c, n, a) => {
    const s = c(o), t = s.findIndex((e) => e.toastId === a);
    t > -1 && n(o, [
      ...s.slice(0, t),
      ...s.slice(t + 1)
    ]);
  });
  return {
    toastsAtom: o,
    addOrUpdateToastAtom: d,
    removeToastAtom: l
  };
}, u = x(f()), A = () => T(u);
export {
  u as ToastContext,
  f as createToastState,
  A as useToastStateAtoms
};
//# sourceMappingURL=index.js.map
